export default (i18n, data) => {
  Object.keys(data).forEach((key) => {
    const obj = {};
    obj[key] = data[key];
    if (i18n.mergeLocaleMessage)
      !i18n.error && i18n.mergeLocaleMessage(i18n.locale.value, obj);
  });
};
